/**
 * Match a keydown event against a shortcut string like `"ctrl+shift+m"`.
 *
 * `ctrl`, `cmd` and `meta` are interchangeable so a single shortcut string
 * works on both macOS and Windows/Linux. The last segment is the key itself.
 */
export function matchesShortcut(e: KeyboardEvent, shortcut: string): boolean {
  const keys = shortcut
    .split('+')
    .map((k) => k.trim().toLowerCase())
    .filter(Boolean);

  if (keys.length === 0) return false;

  const ctrl =
    keys.includes('ctrl') || keys.includes('cmd') || keys.includes('meta');
  const shift = keys.includes('shift');
  const alt = keys.includes('alt');
  const key = keys[keys.length - 1];

  return (
    e.key.toLowerCase() === key &&
    (e.ctrlKey || e.metaKey) === ctrl &&
    e.shiftKey === shift &&
    e.altKey === alt
  );
}
